import { Breadcrumbs, Loading, Page } from "components";
import { format } from "date-fns";
import { EProcessStatus } from "enums";
import { useEffect, useState } from "react";
import { matchPath } from "react-router";
import { inhabitantsAPI } from "services/inhabitantsAPI";

export default function ShowProcess(props) {
  const [process, setProcess] = useState();

  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "Lista de Processamentos", to: "/processes/list" },
    { name: "Detalhes do Processamento", to: "" },
  ];

  const handleGetID = () => {
    const match = matchPath(props.location.pathname, {
      path: "/processes/:id/show",
    });

    return match.params.id;
  };

  const fetchData = async (id) => {
    inhabitantsAPI.get(`/file-processors/${id}`).then(({ data: { data } }) => {
      setProcess(data);
    });
  };

  useEffect(() => {
    fetchData(handleGetID());

    const timer = setInterval(() => {
      fetchData(handleGetID());
    }, 15000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Page>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <section className="cpf-list-detailed">
        <h2>Detalhes do Processamento</h2>

        <div className="field-container">
          <div>
            <span className="field">ID:</span>
            <span className="value">{process && process.id}</span>
          </div>
          <div>
            <span className="field">Status:</span>
            <span className="value">
              {process && EProcessStatus[process.attributes.status_name]}
            </span>
          </div>
          <div>
            <span className="field">Data de criação:</span>
            <span className="value">
              {process &&
                format(
                  new Date(process.attributes.created_at),
                  "dd/MM/yyyy HH:mm"
                )}
            </span>
          </div>
        </div>

        <br />

        {process && (
          <table className="cpf-table">
            <thead>
              <tr>
                <th>CPF</th>
                <th>Motivo</th>
              </tr>
            </thead>
            {process.attributes.errors.length > 0 ? (
              <tbody>
                {process.attributes.errors.map((error, index) => (
                  <tr key={index}>
                    <td>{error.cpf}</td>
                    <td>{error.reason}</td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tr>
                <td colSpan="2" className="text-center">
                  Nenhum erro encontrado
                </td>
              </tr>
            )}
          </table>
        )}
      </section>
    </Page>
  );
}
